import { AppInsights } from '@/app/core/services/AppInsights.service';

export const initializeAppInsights = async () => {
    if (!AppInsights) {
        return;
    }

    await AppInsights.loadAppInsights();
    AppInsights.trackPageView();
};
